import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { CalendarItemsStore } from './calendar-items.store';
import { CalendarItemBackendService } from '../../../services/calendar-item/calendar-item-backend.service';

@Injectable({
  providedIn: 'root',
})
export class CalendarItemsService {
  constructor(
    private calendarItemsStore: CalendarItemsStore,
    private calendarItemBackendService: CalendarItemBackendService
  ) {}

  /**
   * Select timeentries with date filter.
   *
   * @param date Selected Date.
   * @param personID
   */
  getCalendarItemsForDate(date: Date, personID: number): void {
    this.calendarItemsStore.setLoading(true);
    this.calendarItemsStore.remove();

    // API request and Store update
    this.calendarItemBackendService
      .getCalendarItems(date, personID)
      .pipe(tap(() => this.calendarItemsStore.setLoading(false)))
      .subscribe({
        next: (data) => {
          //console.log(data);
          this.calendarItemsStore.upsertMany(data);
        },
        error: (error) => this.calendarItemsStore.setError(error.error),
      });
  }
}
